import { forwardRef } from "react";
import NumberFormat from "react-number-format";

const NumberFormatCustom = forwardRef(function NumberFormatCustom(props, ref) {
	const { onChange, mask, format, ...other } = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={ref}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			format={format}
			mask={mask}
		/>
	);
});

export default NumberFormatCustom;
